import styled from "styled-components";

export const Customisations = styled.div`
    padding:0.5rem 0 0 0;
    display:block;
    overflow: hidden;
    width:100%;
    white-space:nowrap;
    text-overflow: ellipsis;
    font-weight:300;
    font-size:13px;
    text-align:left;
    gap:0.5rem;
`;

export const CustomisationContent = styled.div`
    margin:0.5rem 0 0 0;
    display:flex;
    flex-direction:column;
    align-items:flex-start;
    width:100%;
    &:first-child {
        margin:0;
    }
    gap:0.5rem;
`;

export const CustomisationsPoint = styled.div<any>`
    font-weight: 500;
    font-size: 12px;
    color: ${props => props.caution ? "#FF6B4B" : "#FFF"};
    min-width:max-content;
    padding-bottom:${props => props.padded ? "10px" : ""};
`;

export const CustomisationsData = styled.div<any>`
    color: ${props => props.caution ? "#FF6B4B" : "rgba(255, 255, 255, 0.5)"};
    font-weight:400;
    font-size:${props => props.caution ? "11px" : "12px"};
    text-align:left;
    line-height:15px;
    padding-bottom: 10px;
`;